import { Box, VStack, HStack } from "@chakra-ui/react";
import { Paragraph02, Paragraph04 } from "~/components/Texts";
import { CgNotes } from "react-icons/cg";
import tinycolor from "tinycolor2";

const BILL_TYPE_COMPANY = "company";

export default function OrderDetailsBilling({ shop, order }) {
  if (order.billing.billType === BILL_TYPE_COMPANY)
    return (
      <HStack w="100%" px="4" py="2" align="flex-start" spacing="4">
        <Box
          mt="4"
          p="4"
          borderRadius="full"
          backgroundColor={shop.theme.colors.background.strong}
        >
          <CgNotes
            color={tinycolor
              .mostReadable(
                shop.theme.colors.background.strong,
                [shop.theme.colors.text],
                {
                  includeFallbackColors: true,
                }
              )
              .toHexString()}
          />
        </Box>
        <VStack w="100%" align="flex-start" spacing="1">
          <Paragraph02>
            <b>Factura para empresas</b>
          </Paragraph02>
          <Paragraph04>Razón Social: {order.billing.company.name}</Paragraph04>
          <Paragraph04>CUIT: {order.billing.company.taxId}</Paragraph04>
          <Paragraph04>
            Dirección de facturación: {order.billing.company.address}
          </Paragraph04>
          <Paragraph04>
            Código Postal de facturación: {order.billing.company.zipcode}
          </Paragraph04>
          <Paragraph04>Email de contacto: {order.billing.email}</Paragraph04>
        </VStack>
      </HStack>
    );

  return (
    <HStack w="100%" px="4" py="2" align="flex-start" spacing="4">
      <Box
        mt="4"
        p="4"
        borderRadius="full"
        backgroundColor={shop.theme.colors.background.strong}
      >
        <CgNotes
          color={tinycolor
            .mostReadable(
              shop.theme.colors.background.strong,
              [shop.theme.colors.text],
              {
                includeFallbackColors: true,
              }
            )
            .toHexString()}
        />
      </Box>
      <VStack w="100%" align="flex-start" spacing="1">
        <Paragraph02>
          <b>Factura para Consumidor Final</b>
        </Paragraph02>
        <Paragraph04>Nombre: {order.billing.person.firstname}</Paragraph04>
        <Paragraph04>Apellido: {order.billing.person.lastname}</Paragraph04>
        <Paragraph04>Nº Documento: {order.billing.person.id}</Paragraph04>
        <Paragraph04>Email de contacto: {order.billing.email}</Paragraph04>
      </VStack>
    </HStack>
  );
}
